import styled, { css } from 'styled-components';

export const HeaderSidebarTab = styled.div`
  width: 100%;
  padding: 2rem 1rem;
  cursor: pointer;
  text-align: center;
  font-size: 1.8rem;
  color: var(--color-white);
  background-color: var(--color-brick);
  position: relative;
  &:hover {
    color: var(--color-black);
  }
  ${(props) =>
    props.tabSelected &&
    css`
      background-color: #8b151b;
      &:hover {
        color: var(--color-white);
        cursor: default;
      }
      &::after {
        content: '';
        position: absolute;
        top: 100%;
        left: 50%;
        transform: translate(-50%);
        width: 0;
        height: 0;
        border-top: solid 8px #8b151b;
        border-left: solid 8px transparent;
        border-right: solid 8px transparent;
      }
    `};
`;
